export function ProgressBar({
  checked,
  total,
  className,
  size = "md",
  "aria-label": ariaLabel,
}: {
  checked: number;
  total: number;
  className?: string;
  size?: "sm" | "md" | "lg";
  "aria-label"?: string;
}) {
  const pct = total === 0 ? 0 : Math.round((checked / total) * 100);
  const complete = total > 0 && checked >= total;
  const height = size === "lg" ? "h-3" : size === "sm" ? "h-1.5" : "h-2.5";
  return (
    <div
      className={[height, "overflow-hidden rounded-full bg-slate-100", className ?? ""]
        .filter(Boolean)
        .join(" ")}
      role="progressbar"
      aria-valuenow={total === 0 ? 0 : checked}
      aria-valuemin={0}
      aria-valuemax={total === 0 ? 1 : total}
      aria-label={ariaLabel ?? `${checked} of ${total} complete`}
    >
      <div
        className={[
          "h-full rounded-full transition-all",
          complete ? "bg-success" : "bg-brand-600",
        ].join(" ")}
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}
